export default __webpack_public_path__ + "static/media/credit-card1.2fc16563.svg";